module.exports = __webpack_public_path__ + "static/media/KMH_5221.94a0aa41.jpg";